import React, { useEffect, useState } from 'react';
import firebase from "../../firebaseConfig";
import "../../styles/generalTabs.css";
import {TiDelete, TiPlus} from "react-icons/ti";
import toast from 'react-simple-toasts';

const FlowRoutines = ({ user }) => {
    const [flowRoutinesData, setFlowRoutinesData] = useState([]);
    const [modalActive, setModalActive] = useState(false);
    const [selectedType, setSelectedType] = useState('');
    const [editingCardIndex, setEditingCardIndex] = useState(null);
    
    const routineTypes = [
        "DOMINO EFFECT",
        "EXECUTION",
        "CREATIVITY",
        "TEAM WORK",
        "STUDYING / SKILL ACQUISITION",
        "STAGE PERFORMANCE / COMPETITION",
        "PHYSICAL TRAINING",
        "SOCIAL",
        "COMMUNICATION / SPEECH",
        "BORING / NASTY"
    ];

    useEffect(() => {
        const fetchInputValue = async () => {
            try {
                if (user) {
                    const userId = user.uid;
                    const docRef = firebase.firestore().collection('users').doc(userId);
                    const docSnapshot = await docRef.get();
                    if (docSnapshot.exists) {
                        const data = docSnapshot.data().FlowRoutines_4 || [];
                        setFlowRoutinesData(data);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchInputValue();
    }, [user]);

    const updateFlowRoutinesData = (index, field, value) => {
        setFlowRoutinesData((prevData) => {
            const updatedData = [...prevData];
            if (field.includes('.')) {
                const [parent, child] = field.split('.');
                updatedData[index][parent] = {
                    ...updatedData[index][parent],
                    [child]: value
                };
            } else if (field === null && value !== null) {
                // For EntryStabilizationSection direct update
                updatedData[index] = value;
            } else {
                updatedData[index][field] = value;
            }
            return updatedData;
        });
    };

    const saveFlowRoutinesData = async () => {
        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({ FlowRoutines_4: flowRoutinesData });
                toast('Saved');
            }
        } catch (error) {
            console.log("Error saving data:", error);
            toast('Error saving data');
        }
    };

    const reloadCardData = async () => {
        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                const docSnapshot = await docRef.get();
                if (docSnapshot.exists) {
                    const data = docSnapshot.data().FlowRoutines_4 || [];
                    setFlowRoutinesData(data);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const createNewRoutine = async (type) => {
        try {
            const userId = user.uid;
            const docRef = firebase.firestore().collection('users').doc(userId);
            const newRoutine = {
                type: type,
                singleTask: '',
                preFlowPrimer: '',
                entryStabilization: {
                    intrinsicMotivator: '',
                    whyMatters: '',
                    flowFoundationTriggers: [],
                    catalysts: [],
                    personalCues: []
                },
                release: {
                    shortReset: '',
                    longerReset: '',
                    reentryCue: ''
                },
                recovery: ''
            };

            await docRef.update({
                FlowRoutines_4: firebase.firestore.FieldValue.arrayUnion(newRoutine)
            });
            setFlowRoutinesData(prevData => [...prevData, newRoutine]);
            closeModal();
        } catch (error) {
            console.log("Error creating new routine:", error);
        }
    };

    const handleCreateRoutine = () => {
        if (!selectedType) {
            toast('Please select a routine type');
            return;
        }
        createNewRoutine(selectedType);
    };

    const closeModal = () => {
        setModalActive(false);
        setSelectedType('');
    };

    const handleDelete = async (index) => {
        const updatedData = [...flowRoutinesData];
        updatedData.splice(index, 1);
        setFlowRoutinesData(updatedData);

        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({ FlowRoutines_4: updatedData });
            }
        } catch (error) {
            console.log("Error deleting routine:", error);
        }
    };

    const DisplayModal = () => {
        if (!modalActive) return null;

        return (
            <div className="modal fade show modal-overlay" style={{ display: "block" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            Create Flow Routine
                            <button
                                className="btn-close"
                                style={{ cursor: "pointer" }}
                                type="button"
                                aria-label="Close"
                                onClick={closeModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <div className={"d-flex flex-column"}>
                                    <label htmlFor="typeId">Routine Type</label>
                                    <select
                                        id="typeId"
                                        className="form-select mt-2"
                                        value={selectedType}
                                        onChange={(e) => setSelectedType(e.target.value)}
                                    >
                                        <option value="">-- Select a routine type --</option>
                                        {routineTypes.map((type, idx) => (
                                            <option key={idx} value={type}>{type}</option>
                                        ))}
                                    </select>
                                    <button className="btn btn-primary mt-3" onClick={handleCreateRoutine}>Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="tab-pane containerDashboardContent container-fluid" role="tabpanel" id="tab-4">
            <h5 className={"mt-3"}>
                <span className="introText">
                    "We are what we repeatedly do." - Aristotle
                </span>
            </h5>
            <div className="container">
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    {flowRoutinesData.map((item, index) => (
                        <div key={index} className="col p-2">
                            <FlowRoutineCard 
                                item={item} 
                                index={index} 
                                updateFlowRoutinesData={updateFlowRoutinesData} 
                                handleDelete={handleDelete} 
                                isEditing={editingCardIndex === index}
                                toggleEditing={() => setEditingCardIndex(editingCardIndex === index ? null : index)}
                                saveFlowRoutinesData={saveFlowRoutinesData}
                                reloadCardData={reloadCardData}
                            />
                        </div>
                    ))}
                </div>

                <div className="w-100 d-flex justify-content-center align-items-center mt-3">
                    <TiPlus style={{ fontSize: "1.8em", cursor: "pointer" }} className={"text-primary"} onClick={() => setModalActive(true)} />
                </div>
                <DisplayModal />
            </div>
        </div>
    );
};

export default FlowRoutines;

const FlowRoutineItem = ({ title, content, field, index, updateFlowRoutinesData, isSection, isSubItem, isSubSubItem, isSteps }) => {
    const [localContent, setLocalContent] = useState(content || '');
    const [steps, setSteps] = useState([]);

    useEffect(() => {
        if (isSteps && typeof content === 'string') {
            // Parse steps from string (format: "1. step\n2. step\n3. step")
            const parsedSteps = content.split('\n').filter(step => step.trim()).map(step => {
                const match = step.match(/^\d+\.\s*(.*)/);
                return match ? match[1] : step;
            });
            setSteps(parsedSteps.length > 0 ? parsedSteps : ['']);
        } else {
            setLocalContent(content || '');
        }
    }, [content, isSteps]);

    const handleChange = (value) => {
        setLocalContent(value);
    };

    const handleBlur = () => {
        if (localContent !== content) {
            updateFlowRoutinesData(index, field, localContent);
        }
    };

    const handleStepChange = (stepIndex, value) => {
        const updatedSteps = [...steps];
        updatedSteps[stepIndex] = value;
        setSteps(updatedSteps);
        
        // Convert back to string format
        const stepsString = updatedSteps
            .filter(step => step.trim())
            .map((step, i) => `${i + 1}. ${step}`)
            .join('\n');
        updateFlowRoutinesData(index, field, stepsString);
    };

    const addStep = () => {
        setSteps([...steps, '']);
    };

    const removeStep = (stepIndex) => {
        const updatedSteps = steps.filter((_, i) => i !== stepIndex);
        setSteps(updatedSteps);
        
        const stepsString = updatedSteps
            .filter(step => step.trim())
            .map((step, i) => `${i + 1}. ${step}`)
            .join('\n');
        updateFlowRoutinesData(index, field, stepsString);
    };

    const labelClass = isSection ? 'fw-bold' : isSubItem ? 'fw-semibold small' : isSubSubItem ? 'small text-muted' : 'fw-bold small text-muted';
    const marginBottom = isSection ? 'mb-2' : isSubItem ? 'mb-1' : isSubSubItem ? 'mb-1' : 'mb-2';

    if (isSteps) {
        return (
            <div className={marginBottom}>
                <label className={labelClass} style={{ fontSize: isSubItem ? '0.85rem' : isSubSubItem ? '0.8rem' : '0.9rem', marginBottom: '0.25rem' }}>{title}</label>
                {steps.map((step, stepIndex) => (
                    <div key={stepIndex} className="mb-2 position-relative">
                        <div className="d-flex align-items-center">
                            <span className="me-2 fw-bold">{stepIndex + 1}.</span>
                            <textarea
                                className="form-control"
                                value={step}
                                onChange={(e) => handleStepChange(stepIndex, e.target.value)}
                                style={{ fontSize: '0.9rem' }}
                                rows={1}
                            />
                            {steps.length > 1 && (
                                <TiDelete 
                                    className="text-danger ms-2" 
                                    style={{ fontSize: "1.2em", cursor: "pointer" }} 
                                    onClick={() => removeStep(stepIndex)} 
                                />
                            )}
                        </div>
                    </div>
                ))}
                <button className="btn btn-sm btn-outline-secondary mt-1" onClick={addStep}>+ Add step</button>
            </div>
        );
    }

    return (
        <div className={marginBottom}>
            <label className={labelClass} style={{ fontSize: isSubItem ? '0.85rem' : isSubSubItem ? '0.8rem' : '0.9rem', marginBottom: '0.25rem' }}>{title}</label>
            <textarea
                className="form-control"
                value={localContent}
                onChange={(e) => handleChange(e.target.value)}
                onBlur={handleBlur}
                style={{ minHeight: isSubSubItem ? '40px' : isSubItem ? '45px' : '50px', fontSize: '0.9rem' }}
                rows={isSubSubItem ? 1 : isSubItem ? 2 : 3}
            />
        </div>
    );
};

const FlowRoutineCard = ({ item, index, updateFlowRoutinesData, handleDelete, isEditing, toggleEditing, saveFlowRoutinesData, reloadCardData }) => {
    const handleSave = async () => {
        await saveFlowRoutinesData();
        toggleEditing();
    };

    const handleCancel = async () => {
        await reloadCardData();
        toggleEditing();
    };

    return (
        <div className="card h-100">
            <div className="card-header text-center" style={{ backgroundColor: '#f8f9fa', cursor: "pointer" }} onClick={toggleEditing}>
                <h5 className="mb-0">{item.type}</h5>
            </div>
            <div className="card-body" style={{ position: 'relative', padding: '1rem' }}>
                <TiDelete className="text-danger" style={{ fontSize: "1.3em", cursor: "pointer", position: "absolute", top: "8px", right: "8px" }} onClick={() => handleDelete(index)} />
                
                {isEditing ? (
                    <div>
                        <FlowRoutineItem title="Single task / activity" content={item.singleTask} field="singleTask" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSection={true} />
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <FlowRoutineItem title="Pre-flow primer (2-5 simple steps)" content={item.preFlowPrimer} field="preFlowPrimer" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSection={true} isSteps={true} />
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <h6 className="fw-bold mb-2" style={{ color: '#000', fontSize: '0.9rem' }}>ENTRY & STABILIZATION</h6>
                        <EntryStabilizationSection entryStabilization={item.entryStabilization} index={index} updateFlowRoutinesData={updateFlowRoutinesData} />
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <h6 className="fw-bold mb-2" style={{ color: '#000', fontSize: '0.9rem' }}>RELEASE (LOW-DEMAND RESET)</h6>
                        <div style={{ paddingLeft: '0.5rem' }}>
                            <FlowRoutineItem title="Short reset, 1-5 min" content={item.release?.shortReset} field="release.shortReset" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                            <FlowRoutineItem title="Longer reset, 10-20+ min if needed" content={item.release?.longerReset} field="release.longerReset" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                            <FlowRoutineItem title="Re-entry cue" content={item.release?.reentryCue} field="release.reentryCue" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                        </div>
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <FlowRoutineItem title="Recovery, post-block recharge" content={item.recovery} field="recovery" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSection={true} />
                        
                        <div className="d-flex gap-2 mt-3">
                            <button className="btn btn-primary btn-sm" onClick={handleSave}>Save</button>
                            <button className="btn btn-secondary btn-sm" onClick={handleCancel}>Cancel</button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="mb-2">
                            <strong className="text-uppercase">SINGLE TASK / ACTIVITY</strong>
                            <p>{item.singleTask || 'Not specified'}</p>
                        </div>
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <div className="mb-2">
                            <strong className="text-uppercase">PRE-FLOW PRIMER (2-5 SIMPLE STEPS)</strong>
                            {item.preFlowPrimer && typeof item.preFlowPrimer === 'string' ? (
                                <ol>
                                    {item.preFlowPrimer.split('\n').filter(step => step.trim()).map((step, i) => (
                                        <li key={i}>{step.replace(/^\d+\.\s*/, '')}</li>
                                    ))}
                                </ol>
                            ) : (
                                <p>Not specified</p>
                            )}
                        </div>
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <h6 className="fw-bold mb-2 text-uppercase" style={{ color: '#000', fontSize: '0.9rem' }}>ENTRY & STABILIZATION</h6>
                        <EntryStabilizationView entryStabilization={item.entryStabilization} />
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <h6 className="fw-bold mb-2 text-uppercase" style={{ color: '#000', fontSize: '0.9rem' }}>RELEASE</h6>
                        <div style={{ paddingLeft: '0.5rem' }}>
                            <p>Short reset, 1-5 min:     {item.release?.shortReset || 'Not specified'}</p>
                            <p>Longer reset, 10-20+ min if needed:   {item.release?.longerReset || 'Not specified'}</p>
                            <p>Re-entry cue:     {item.release?.reentryCue || 'Not specified'}</p>
                        </div>
                        
                        <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                        
                        <div className="mb-2">
                            <strong className="text-uppercase">RECOVERY</strong>
                            <p>{item.recovery || 'Not specified'}</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const EntryStabilizationView = ({ entryStabilization }) => {
    if (!entryStabilization) return <p>Not specified</p>;

    return (
        <div style={{ paddingLeft: '0.5rem' }}>
            <div className="mb-2">
                <strong className="small text-uppercase">1. INTRINSIC MOTIVATOR</strong>
                <p className="small">
                    {entryStabilization.intrinsicMotivator || 'Not specified'}
                    {entryStabilization.intrinsicMotivator && entryStabilization.whyMatters && `: ${entryStabilization.whyMatters}`}
                </p>
            </div>
            
            <div className="mb-2">
                <strong className="small text-uppercase">2. FLOW FOUNDATION TRIGGERS</strong>
                {entryStabilization.flowFoundationTriggers && entryStabilization.flowFoundationTriggers.length > 0 ? (
                    entryStabilization.flowFoundationTriggers.map((trigger, idx) => (
                        <div key={idx} className="small mb-1">
                            {trigger.type}: {trigger.explanation || 'Not specified'}
                        </div>
                    ))
                ) : (
                    <p className="small">Not specified</p>
                )}
            </div>
            
            <div className="mb-2">
                <strong className="small text-uppercase">3. CATALYSTS</strong>
                {entryStabilization.catalysts && entryStabilization.catalysts.length > 0 ? (
                    entryStabilization.catalysts.map((catalyst, idx) => (
                        <div key={idx} className="small mb-1">
                            {catalyst.type}: {catalyst.explanation || 'Not specified'}
                        </div>
                    ))
                ) : (
                    <p className="small">Not specified</p>
                )}
            </div>
            
            <div className="mb-2">
                <strong className="small text-uppercase">4. PERSONAL CUES / AMPLIFIERS</strong>
                {entryStabilization.personalCues && entryStabilization.personalCues.length > 0 ? (
                    entryStabilization.personalCues.map((cue, idx) => (
                        <div key={idx} className="small mb-1">
                            {cue.type}: {cue.explanation || 'Not specified'}
                        </div>
                    ))
                ) : (
                    <p className="small">Not specified</p>
                )}
            </div>
        </div>
    );
};

const EntryStabilizationSection = ({ entryStabilization, index, updateFlowRoutinesData }) => {
    const [localData, setLocalData] = useState(entryStabilization || {
        intrinsicMotivator: '',
        whyMatters: '',
        flowFoundationTriggers: [],
        catalysts: [],
        personalCues: []
    });

    useEffect(() => {
        setLocalData(entryStabilization || {
            intrinsicMotivator: '',
            whyMatters: '',
            flowFoundationTriggers: [],
            catalysts: [],
            personalCues: []
        });
    }, [entryStabilization]);

    const handleSave = () => {
        updateFlowRoutinesData(index, 'entryStabilization', localData);
    };

    const addFlowFoundationTrigger = () => {
        setLocalData({
            ...localData,
            flowFoundationTriggers: [...localData.flowFoundationTriggers, { type: '', explanation: '' }]
        });
    };

    const removeFlowFoundationTrigger = (idx) => {
        setLocalData({
            ...localData,
            flowFoundationTriggers: localData.flowFoundationTriggers.filter((_, i) => i !== idx)
        });
        handleSave();
    };

    const updateFlowFoundationTrigger = (idx, field, value) => {
        const updated = [...localData.flowFoundationTriggers];
        updated[idx][field] = value;
        setLocalData({ ...localData, flowFoundationTriggers: updated });
        handleSave();
    };

    const addCatalyst = () => {
        setLocalData({
            ...localData,
            catalysts: [...localData.catalysts, { type: '', explanation: '' }]
        });
    };

    const removeCatalyst = (idx) => {
        setLocalData({
            ...localData,
            catalysts: localData.catalysts.filter((_, i) => i !== idx)
        });
        handleSave();
    };

    const updateCatalyst = (idx, field, value) => {
        const updated = [...localData.catalysts];
        updated[idx][field] = value;
        setLocalData({ ...localData, catalysts: updated });
        handleSave();
    };

    const addPersonalCue = () => {
        setLocalData({
            ...localData,
            personalCues: [...localData.personalCues, { type: '', explanation: '' }]
        });
    };

    const removePersonalCue = (idx) => {
        setLocalData({
            ...localData,
            personalCues: localData.personalCues.filter((_, i) => i !== idx)
        });
        handleSave();
    };

    const updatePersonalCue = (idx, field, value) => {
        const updated = [...localData.personalCues];
        updated[idx][field] = value;
        setLocalData({ ...localData, personalCues: updated });
        handleSave();
    };

    const flowFoundationOptions = [
        'Complete concentration',
        'Clear goal + challenge edge',
        'Challenge-skill balance',
        'Immediate feedback'
    ];

    const catalystOptions = [
        'Deep Embodiment',
        'Rich Environments',
        'High Consequences',
        'Creativity',
        'Other'
    ];

    const personalCueOptions = [
        'Music',
        'Timer',
        'Tea / coffee',
        'Breathwork',
        'Visualization',
        'Workspace / lighting',
        'Gear / clothing',
        'Movement / warm-up',
        'Scent',
        'Other'
    ];

    return (
        <div style={{ paddingLeft: '0.5rem' }}>
            <p className="small text-muted mb-2">Choose the intrinsic motivator for the activity, then start with the Flow Foundation Triggers. Add only the catalysts and personal cues/amplifiers that genuinely support this routine. You do not need to fill every optional category.</p>
            <p className="small text-muted mb-2 fst-italic">Start small. Stack intelligently. Expand only when the added cue improves focus, steadiness, or engagement.</p>
            
            {/* INTRINSIC MOTIVATOR */}
            <div className="mb-3">
                <label className="fw-bold small text-uppercase">1. INTRINSIC MOTIVATOR</label>
                <p className="small text-muted mb-1">Choose the primary intrinsic motivator for this activity, then write one line explaining why the activity matters.</p>
                <select
                    className="form-select form-select-sm mb-2"
                    value={localData.intrinsicMotivator}
                    onChange={(e) => {
                        setLocalData({ ...localData, intrinsicMotivator: e.target.value });
                        handleSave();
                    }}
                >
                    <option value="">-- Select --</option>
                    <option value="Autonomy">Autonomy</option>
                    <option value="Curiosity">Curiosity</option>
                    <option value="Passion">Passion</option>
                    <option value="Purpose">Purpose</option>
                </select>
                {localData.intrinsicMotivator && (
                    <div className="mb-2">
                        <label className="small">Why this activity matters:</label>
                        <textarea
                            className="form-control form-control-sm"
                            value={localData.whyMatters}
                            onChange={(e) => {
                                setLocalData({ ...localData, whyMatters: e.target.value });
                            }}
                            onBlur={handleSave}
                            rows={2}
                        />
                    </div>
                )}
            </div>

            {/* FLOW FOUNDATION TRIGGERS */}
            <div className="mb-3">
                <label className="fw-bold small text-uppercase">2. FLOW FOUNDATION TRIGGERS</label>
                <p className="small text-muted mb-1">Choose 1–3 first. Use all four when the routine genuinely uses the full Flow Foundation Triggers.</p>
                <button className="btn btn-sm btn-outline-secondary mb-2" onClick={addFlowFoundationTrigger}>+ Add Flow Foundation Trigger</button>
                {localData.flowFoundationTriggers.map((trigger, idx) => (
                    <div key={idx} className="mb-2 position-relative" style={{ backgroundColor: '#f8f9fa', padding: '0.5rem', borderRadius: '4px' }}>
                        <TiDelete 
                            className="text-danger" 
                            style={{ fontSize: "1em", cursor: "pointer", position: "absolute", top: "4px", right: "4px" }} 
                            onClick={() => removeFlowFoundationTrigger(idx)} 
                        />
                        <select
                            className="form-select form-select-sm mb-2"
                            value={trigger.type}
                            onChange={(e) => updateFlowFoundationTrigger(idx, 'type', e.target.value)}
                        >
                            <option value="">-- Select --</option>
                            {flowFoundationOptions.map((option, i) => (
                                <option key={i} value={option}>{option}</option>
                            ))}
                        </select>
                        {trigger.type && (
                            <div>
                                <label className="small">{trigger.type}:</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    value={trigger.explanation}
                                    onChange={(e) => updateFlowFoundationTrigger(idx, 'explanation', e.target.value)}
                                    rows={2}
                                    placeholder={trigger.type === 'Complete concentration' ? 'How will you protect focus and reduce distractions?' :
                                              trigger.type === 'Clear goal + challenge edge' ? 'What is the specific target, and what makes it challenging enough to require full attention?' :
                                              trigger.type === 'Challenge-skill balance' ? 'Challenge rating, skill/readiness rating, and adjustment if mismatched.' :
                                              trigger.type === 'Immediate feedback' ? 'What person, tool, app, signal, or metric tells you whether you are on track?' : ''}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* CATALYSTS */}
            <div className="mb-3">
                <label className="fw-bold small text-uppercase">3. CATALYSTS</label>
                <p className="small text-muted mb-1">Optional — choose 0–2 if they add a useful edge.</p>
                <button className="btn btn-sm btn-outline-secondary mb-2" onClick={addCatalyst}>+ Add catalyst</button>
                {localData.catalysts.map((catalyst, idx) => (
                    <div key={idx} className="mb-2 position-relative" style={{ backgroundColor: '#f8f9fa', padding: '0.5rem', borderRadius: '4px' }}>
                        <TiDelete 
                            className="text-danger" 
                            style={{ fontSize: "1em", cursor: "pointer", position: "absolute", top: "4px", right: "4px" }} 
                            onClick={() => removeCatalyst(idx)} 
                        />
                        <select
                            className="form-select form-select-sm mb-2"
                            value={catalyst.type}
                            onChange={(e) => updateCatalyst(idx, 'type', e.target.value)}
                        >
                            <option value="">-- Select --</option>
                            {catalystOptions.map((option, i) => (
                                <option key={i} value={option}>{option}</option>
                            ))}
                        </select>
                        {catalyst.type && (
                            <div>
                                <label className="small">{catalyst.type}:</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    value={catalyst.explanation}
                                    onChange={(e) => updateCatalyst(idx, 'explanation', e.target.value)}
                                    rows={2}
                                    placeholder="Explanation..."
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* PERSONAL CUES / AMPLIFIERS */}
            <div className="mb-3">
                <label className="fw-bold small text-uppercase">4. PERSONAL CUES / AMPLIFIERS</label>
                <p className="small text-muted mb-1">Optional — choose 0–2 first if they steady attention, raise engagement, or reduce friction.</p>
                <button className="btn btn-sm btn-outline-secondary mb-2" onClick={addPersonalCue}>+ Add cue/amplifier</button>
                {localData.personalCues.map((cue, idx) => (
                    <div key={idx} className="mb-2 position-relative" style={{ backgroundColor: '#f8f9fa', padding: '0.5rem', borderRadius: '4px' }}>
                        <TiDelete 
                            className="text-danger" 
                            style={{ fontSize: "1em", cursor: "pointer", position: "absolute", top: "4px", right: "4px" }} 
                            onClick={() => removePersonalCue(idx)} 
                        />
                        <select
                            className="form-select form-select-sm mb-2"
                            value={cue.type}
                            onChange={(e) => updatePersonalCue(idx, 'type', e.target.value)}
                        >
                            <option value="">-- Select --</option>
                            {personalCueOptions.map((option, i) => (
                                <option key={i} value={option}>{option}</option>
                            ))}
                        </select>
                        {cue.type && (
                            <div>
                                <label className="small">{cue.type}:</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    value={cue.explanation}
                                    onChange={(e) => updatePersonalCue(idx, 'explanation', e.target.value)}
                                    rows={2}
                                    placeholder="Explanation..."
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
